<template>
  <v-row justify="center">
    <v-navigation-drawer
      absolute
      left
      v-model="isActive"
      :width="width"
      :max-width="maxWidth"
      class="pa-4"
    >
      <!-- コンポーネントを毎回削除 -->
      <div v-if="isActive" style="text-align: right">
        <v-icon @click="close">mdi-close</v-icon>
        <slot />
      </div>
    </v-navigation-drawer>
  </v-row>
</template>

<script>
import { Store } from "@/store/Store.js";

/* storeを利用したdrawer */

export default {
  data() {
    return {
      isActive: false,
    };
  },
  props: {
    width: {
      type: String,
      defaultValue: "100%",
    },
    maxWidth: {
      type: String,
      defaultValue: "100%",
    },
  },

  mounted() {
    this.$watch(
      () => [Store.getters["Drawer/getState"], this.isActive],
      (data) => {
        const { isActive } = data[0];
        this.isActive = isActive;
      },
      {
        immidiate: true,
        deep: true,
      }
    );
  },
  methods: {
    close() {
      Store.dispatch("Drawer/close");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  z-index: 99999;
}
</style>
